import { render, staticRenderFns } from "./SfCheckbox.vue?vue&type=template&id=18d4902c&"
import script from "./SfCheckbox.vue?vue&type=script&lang=js&"
export * from "./SfCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SfCheckbox.vue?vue&type=style&index=0&id=18d4902c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports